import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Experiences, NotificationExperienceMarkKeys } from '../types';
export var ufoMarkNameByPhase = function ufoMarkNameByPhase(key, phase) {
  return "".concat(key).concat(phase === 'start' ? 'Start' : 'End');
};
var ufoMarkTiming = function ufoMarkTiming(key) {
  return {
    key: key,
    startMark: ufoMarkNameByPhase(key, 'start'),
    endMark: ufoMarkNameByPhase(key, 'end')
  };
};
export var ALLOWED_EXPERIENCES_FOR_MARKS = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, NotificationExperienceMarkKeys.API_WITHOUT_CONTENT, [Experiences.RENDER_NOTIFICATIONS_WITHOUT_CONTENT, Experiences.RENDER_NOTIFICATIONS_WITH_CONTENT]), NotificationExperienceMarkKeys.API_WITH_CONTENT, [Experiences.RENDER_NOTIFICATIONS_WITH_CONTENT]), NotificationExperienceMarkKeys.NOTIFICATIONS_INITIAL_MOUNT, [Experiences.RENDER_NOTIFICATIONS_WITHOUT_CONTENT, Experiences.RENDER_NOTIFICATIONS_WITH_CONTENT]), NotificationExperienceMarkKeys.NOTIFICATIONS_FEED_SKELETON_MOUNT, [Experiences.RENDER_NOTIFICATIONS_WITHOUT_CONTENT, Experiences.RENDER_NOTIFICATIONS_WITH_CONTENT]), NotificationExperienceMarkKeys.NOTIFICATION_LIGHTWEIGHT_RENDER, [Experiences.RENDER_NOTIFICATIONS_WITH_CONTENT]);
export var allowedExperienceTimings = function allowedExperienceTimings(experience) {
  var timings = [];
  var entries = Object.entries(ALLOWED_EXPERIENCES_FOR_MARKS);
  entries.forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      experiences = _ref2[1];
    if (experiences.includes(experience)) {
      timings.push(ufoMarkTiming(key));
    }
  });
  return timings;
};
export var composeExperienceName = function composeExperienceName(_ref3) {
  var name = _ref3.name,
    nameId = _ref3.nameId;
  if (nameId) {
    return "".concat(name, "/").concat(nameId);
  }
  return name;
};